(function($) {


    // Complete order
    function edit_account(e){

        e.preventDefault()

        let $form = $(this);

        let url = ghostpress_params.ajax_url + "&action=edit_account",
            data = $form.serializeArray()

        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
            .done((response, textStatus, jqXHR) => {

                // Scroll to notices
                $("html").animate({
                    scrollTop: 0
                }, 1000);
                let success = response.success

                if(success){
                    $form.find('.clean-on-success').val('');
                }else{
                }

                if (typeof response.data !== "undefined" && typeof response.data.reload !== "undefined" && response.data.reload){
                    window.location.reload()
                }

            })

    }

    let $form = $("form.edit-account");

    $form.on("submit", edit_account);

})(jQuery);
